import React from 'react';
import './StatsBar.scss';

// ── Types ─────────────────────────────────────────────────────────────────────

export interface StatsBarItem {
  key: string;
  /** Short label shown above the value (uppercase, muted). */
  label: string;
  /** Formatted value string (e.g. "€ 1,234.00"). */
  value: string;
  /** Colour accent for the value. Defaults to 'default' (dark). */
  variant?: 'default' | 'positive' | 'negative';
}

export interface StatsBarProps {
  items: StatsBarItem[];
  /**
   * When true squares the bottom corners, removes the bottom border and
   * collapses the margin so the bar connects flush to a DetailedList below it.
   */
  flush?: boolean;
  className?: string;
}

// ── Component ─────────────────────────────────────────────────────────────────

const StatsBar: React.FC<StatsBarProps> = ({ items, flush, className }) => {
  if (!items || items.length === 0) return null;

  const cls = [
    'stats-bar',
    flush ? 'stats-bar--flush' : '',
    className ?? '',
  ].filter(Boolean).join(' ');

  return (
    <div className={cls}>
      {items.map(item => (
        <div key={item.key} className="stats-bar__item">
          <span className="stats-bar__label">{item.label}</span>
          <span className={`stats-bar__value stats-bar__value--${item.variant ?? 'default'}`}>
            {item.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export default StatsBar;

